export enum AdtractionIdEnumSwe {
  Cat = "1644323632",
  Dog = "1644323373",
}

export enum AdtractionIdEnumGer {
  OpCat = "1780994220",
  OpDog = "1780994161",
  HealthCat = "1740439525",
  HealthDog = "1740439523",
  Liability = "1780994257",
}

export enum AddrevenueIdEnumGer {
  OpCat = "Katzenop",
  OpDog = "Hundeop",
  HealthCat = "Katzenkranken­ver­sicherung",
  HealthDog = "Hunde­kranken­versicherung",
  Liability = "Hundehaft",
}

export enum AddrevenueIdEnumFra {
  HealthCat = "AssuranceChat",
  HealthDog = "AssuranceChien",
}

export enum FinanceAdsCategoryEnumGer {
  OpCat = "kopv",
  OpDog = "hopv",
  HealthCat = "kkv",
  HealthDog = "hkv",
  Liability = "hhv",
}

const DAY = 60 * 60 * 24;

export const financeAdsCookie = {
  name: "severseitigem",
  maxAge: DAY * 30,
};

export const financeAdsQueryParamName = "s_id";

export const leadAllianceTracking = {
  queryParam: "lea_source",
  cookieName: "lea_source_pc",
  maxAge: DAY * 30,
};
